


























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { IUser } from '../../store/profile/types';
import DisplayNameInput from '~/components/Settings/DisplayNameInput.vue';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({ components: { DisplayNameInput, TwoFactorAuthInputPrompt } })
export default class UpdateDisplayName extends Mixins(AuthQuery) {
  @State(profile => profile.user, { namespace: 'profile' })
  readonly user!: IUser;

  @Prop(Function) readonly closeDialog!: () => void;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => any;

  editing = false;
  newDisplayName = '';
  updatedDisplayNameSnackbarText = '';
  successSnackbar = false;
  displayNameValid = false;

  handleValidityChange(valid: boolean) {
    this.displayNameValid = valid;
  }

  async handleSave() {
    await this.doAuthQuery(async totpToken => {
      const results = await this.updateUser({
        displayName: this.newDisplayName,
        ignoreSnackbar: true,
        rethrowErrorCodes: twoFaErrorCodes,
        totpToken,
      });
      this.editing = false;
      if (results.success) {
        this.updatedDisplayNameSnackbarText = this.$t(
          'components.settings.updateDisplayName.sucessfulUpdate',
          { newDisplayName: this.newDisplayName },
        ) as string;
        this.successSnackbar = true;
      }
      this.newDisplayName = '';
    }, TwoFaCheckpoint.accountModifications);
  }
}
